import React from 'react';
import { Button, Col, FormLabel, Row } from 'react-bootstrap';
import { Plus } from 'react-bootstrap-icons';
import InputCell from './InputCell';
import CurrencyInput from '../../../common/CurrencyInput';

const EMPTY_ROW = { description: '', amount: '' };

const yesNoOptions = ['No', 'Yes'];

// One Unit / Condo panel: Yes/No radio plus the Description / Amount rows.
const InvoicePanel = ({ label, flagKey, rowsKey, formValues, onChange }) => {
  const rows = formValues[rowsKey] || [];

  const updateRow = (index, key, value) => {
    onChange(rowsKey, rows.map((row, i) => (i === index ? { ...row, [key]: value } : row)));
  };

  return (
    <Col className="border p-2 bg-light" style={{ borderRadius: '10px' }}>
      <div className="w-100 d-flex align-items-center justify-content-between p-1">
        <FormLabel className="midFont font-weight-bold mr-2 mb-0">{label}</FormLabel>
        <InputCell
          field={{ key: flagKey, type: 'radio', options: yesNoOptions }}
          formValues={{ [flagKey]: formValues[flagKey] ? 'Yes' : 'No' }}
          onChange={e => onChange(flagKey, e.target.value === 'Yes')}
        />
      </div>
      {formValues[flagKey] && (
        <div className="px-1">
          {rows.map((row, index) => (
            <Row key={index} className="col-12 pr-0 flex-nowrap align-items-end mb-2">
              <Col xs={7} className="px-1" style={{ minWidth: 0 }}>
                <InputCell
                  field={{ key: 'description', label: 'Description', type: 'text' }}
                  formValues={row}
                  onChange={value => updateRow(index, 'description', value)}
                />
              </Col>
              <Col xs={4} className="px-1" style={{ minWidth: 0 }}>
                <FormLabel className="midFont mt-2 mb-2">Amount</FormLabel>
                <CurrencyInput
                  value={row.amount === '' || row.amount == null ? '' : Number(row.amount)}
                  onChange={value => updateRow(index, 'amount', value === '' ? '' : Math.abs(value))}
                  height="34px"
                  inputStyle={{ textAlign: 'right' }}
                />
              </Col>
              <Col xs="auto" className="px-1 d-flex align-items-end" style={{ flexShrink: 0 }}>
                <Button
                  variant="outline-danger"
                  className="mx-1"
                  onClick={() => onChange(rowsKey, rows.filter((_, i) => i !== index))}
                >
                  X
                </Button>
              </Col>
            </Row>
          ))}
          <Button
            variant="outline-dark"
            className="align-self-start my-2 d-flex align-items-center"
            size="sm"
            onClick={() => onChange(rowsKey, [...rows, { ...EMPTY_ROW }])}
          >
            <Plus size={24} />
            {rows.length === 0 && <span className="ml-2">Click To Add</span>}
          </Button>
        </div>
      )}
    </Col>
  );
};

const OpenInvoicesInput = ({ formValues, onChange }) => (
  <Col xs={12} className="mb-4 px-0">
    <div className="card p-2 px-3">
      <Row>
        <Col xs={12} className="mb-2">
          <InputCell
            field={{ key: 'openInvoices', label: 'Open Invoices', type: 'radio', options: yesNoOptions }}
            formValues={formValues}
            onChange={e => onChange('openInvoices', e.target.value)}
          />
        </Col>
        {formValues.openInvoices === 'Yes' && (
          <Col xs={12} className="mb-2 px-4 pt-2">
            <Row className="px-2" style={{ gap: '14px', alignItems: 'flex-start' }}>
              <InvoicePanel
                label="Unit"
                flagKey="openInvoicesUnit"
                rowsKey="openInvoicesUnitCases"
                formValues={formValues}
                onChange={onChange}
              />
              <InvoicePanel
                label="Condo"
                flagKey="openInvoicesCondo"
                rowsKey="openInvoicesCondoCases"
                formValues={formValues}
                onChange={onChange}
              />
            </Row>
          </Col>
        )}
      </Row>
    </div>
  </Col>
);

export default OpenInvoicesInput;
